/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: tXkSR39sgCDWSitZxC5xFV
// Component: pFgBG9DS0D

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  renderPlasmicSlot,
  StrictProps,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: tXkSR39sgCDWSitZxC5xFV/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "../PP__plasmickit_design_system.css"; // plasmic-import: tXkSR39sgCDWSitZxC5xFV/projectcss
import sty from "./PlasmicDropdownOverlay.module.css"; // plasmic-import: pFgBG9DS0D/css

createPlasmicElementProxy;

export type PlasmicDropdownOverlay__VariantMembers = {};
export type PlasmicDropdownOverlay__VariantsArgs = {};
type VariantPropType = keyof PlasmicDropdownOverlay__VariantsArgs;
export const PlasmicDropdownOverlay__VariantProps =
  new Array<VariantPropType>();

export type PlasmicDropdownOverlay__ArgsType = { children?: React.ReactNode };
type ArgPropType = keyof PlasmicDropdownOverlay__ArgsType;
export const PlasmicDropdownOverlay__ArgProps = new Array<ArgPropType>(
  "children"
);

export type PlasmicDropdownOverlay__OverridesType = {
  root?: Flex__<"div">;
};

export interface DefaultDropdownOverlayProps {
  children?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicDropdownOverlay__RenderFunc(props: {
  variants: PlasmicDropdownOverlay__VariantsArgs;
  args: PlasmicDropdownOverlay__ArgsType;
  overrides: PlasmicDropdownOverlay__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_tXkSR39sgCDWSitZxC5xFV",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      {renderPlasmicSlot({
        defaultContents: null,
        value: args.children,
      })}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicDropdownOverlay__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicDropdownOverlay__VariantsArgs;
    args?: PlasmicDropdownOverlay__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicDropdownOverlay__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicDropdownOverlay__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDropdownOverlay__ArgProps,
          internalVariantPropNames: PlasmicDropdownOverlay__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicDropdownOverlay__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDropdownOverlay";
  } else {
    func.displayName = `PlasmicDropdownOverlay.${nodeName}`;
  }
  return func;
}

export const PlasmicDropdownOverlay = Object.assign(
  // Top-level PlasmicDropdownOverlay renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicDropdownOverlay
    internalVariantProps: PlasmicDropdownOverlay__VariantProps,
    internalArgProps: PlasmicDropdownOverlay__ArgProps,
  }
);

export default PlasmicDropdownOverlay;
/* prettier-ignore-end */
